export const siteInfo = {
  name: '黑料吃瓜',
  tagline: '24小时不打烊，全网黑料独家首发',
  description: '黑料吃瓜网24小时不打烊，首页实时更新全网黑料吃瓜视频、每日大赛现场、网红明星塌房与反差大瓜。',
  keywords: '黑料吃瓜,黑料吃瓜视频,每日大赛,网红反差,明星塌房,黑料不打烊,吃瓜爆料网',
  url: '/',
  foundedYear: 2026,
  email: 'hello@kk10010.com',
  wechat: 'heiliao_chigua',
  weibo: '@黑料吃瓜官方',
  copyright: '© 2026 黑料吃瓜 版权所有',
};